// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.111.1_postcss@8.5.30_/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.111.1_postcss@8.5.30_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.addTeny .back {
  margin: 5px 0 0 30px;
}
.addTeny .contain-teny {
  display: flex;
  flex-direction: row;
  justify-content: space-evenly;
}
.addTeny .contain-teny .formTeny {
  background: #fff;
  border-radius: 5px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
  padding: 20px 47px;
  max-height: 570px;
  overflow-y: auto;
}
.addTeny .contain-teny .formTeny .titre {
  text-align: center;
  text-transform: uppercase;
  font-weight: 550;
  font-size: 20px;
}
.addTeny .contain-teny .formTeny .tenyZ, .addTeny .contain-teny .formTeny .selection-theme {
  display: flex;
  flex-direction: column;
  margin: 10px 0;
}
.addTeny .contain-teny .formTeny .tenyZ .label-tenyZ, .addTeny .contain-teny .formTeny .selection-theme .label-tenyZ {
  font-size: 17px;
  font-weight: 550;
  padding-bottom: 5px;
}
.addTeny .contain-teny .formTeny .dowload {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
.addTeny .contain-teny .apercu-teny {
  width: 500px;
  background: #fff;
  border-radius: 5px;
  padding: 0 20px;
  margin: 20px;
  position: relative;
  max-height: 580px;
  overflow-y: auto;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
}
.addTeny .contain-teny .apercu-teny .entete {
  display: flex;
  flex-direction: row;
}
.addTeny .contain-teny .apercu-teny .entete img {
  height: 55px;
  width: 55px;
  margin: 15px 15px 15px 0;
  border: 1px solid #efefef;
  border-radius: 50px;
}
.addTeny .contain-teny .apercu-teny .entete .date {
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.addTeny .contain-teny .apercu-teny .entete .date .title,
.addTeny .contain-teny .apercu-teny .entete .date .date-publication {
  display: flex;
  margin: 0;
}
.addTeny .contain-teny .apercu-teny .entete .date .title {
  font-size: 18px;
  color: #050505;
  font-weight: 600;
}
.addTeny .contain-teny .apercu-teny .entete .date .date-publication {
  color: #65676b;
  font-size: 15px;
}
.addTeny .contain-teny .apercu-teny .teny p {
  font-size: 17px;
}
.addTeny .contain-teny .apercu-teny .teny img, .addTeny .contain-teny .apercu-teny .teny video {
  margin: 0;
  padding: 0;
  width: 100%;
  height: auto;
  border-radius: 5px;
  display: block;
}
.addTeny .contain-teny .apercu-teny .teny .audio-container {
  display: flex;
  flex-direction: column;
  margin: 10px auto;
}
.addTeny .contain-teny .apercu-teny .theme-teny p {
  font-size: 18px;
  font-weight: 550;
}`, "",{"version":3,"sources":["webpack://./src/pages/TenyZaraina/CreateTenyZaraina/addTenyZaraina.scss"],"names":[],"mappings":"AAEE;EACE,oBAAA;AADJ;AAIE;EACE,aAAA;EACA,mBAAA;EACA,6BAAA;AAFJ;AAII;EACE,gBAAA;EACA,kBAAA;EACA,uCAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;AAFN;AAIM;EACE,kBAAA;EACA,yBAAA;EACA,gBAAA;EACA,eAAA;AAFR;AAKM;EACE,aAAA;EACA,sBAAA;EACA,cAAA;AAHR;AAKQ;EACE,eAAA;EACA,gBAAA;EACA,mBAAA;AAHV;AAOM;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;AALR;AASI;EACE,YAAA;EACA,gBAAA;EACA,kBAAA;EACA,eAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,uCAAA;AAPN;AASM;EACE,aAAA;EACA,mBAAA;AAPR;AASQ;EACE,YAAA;EACA,WAAA;EACA,wBAAA;EACA,yBAAA;EACA,mBAAA;AAPV;AAUQ;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;AARV;AAUQ;;EAEI,aAAA;EACA,SAAA;AARZ;AAWU;EACE,eAAA;EACA,cAAA;EACA,gBAAA;AATZ;AAYU;EACE,cAAA;EACA,eAAA;AAVZ;AAgBQ;EACE,eAAA;AAdV;AAiBQ;EACE,SAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,cAAA;AAfV;AAkBQ;EACE,aAAA;EACA,sBAAA;EACA,iBAAA;AAhBV;AAqBQ;EACE,eAAA;EACA,gBAAA;AAnBV","sourcesContent":[".addTeny{\n\n  .back{\n    margin: 5px 0 0 30px;\n  }\n\n  .contain-teny{\n    display: flex;\n    flex-direction: row;\n    justify-content: space-evenly;\n\n    .formTeny{\n      background: #fff;\n      border-radius: 5px;\n      box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);\n      padding: 20px 47px;\n      max-height: 570px;\n      overflow-y: auto;\n      \n      .titre{\n        text-align: center;\n        text-transform: uppercase;\n        font-weight: 550;\n        font-size: 20px;\n      }\n\n      .tenyZ, .selection-theme{\n        display: flex;\n        flex-direction: column;\n        margin: 10px 0;\n\n        .label-tenyZ{\n          font-size: 17px;\n          font-weight: 550;\n          padding-bottom: 5px;\n        }\n      }\n\n      .dowload{\n        display: flex; \n        flex-direction: row;\n        justify-content: space-between;\n      }\n    }\n\n    .apercu-teny{\n      width: 500px;\n      background: #fff;\n      border-radius: 5px;\n      padding: 0 20px;\n      margin: 20px;\n      position: relative;\n      max-height: 580px;\n      overflow-y: auto;\n      box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);\n    \n      .entete {\n        display: flex;\n        flex-direction: row;\n        \n        img {\n          height: 55px;\n          width: 55px;\n          margin: 15px 15px 15px 0;\n          border: 1px solid #efefef;\n          border-radius: 50px;\n        }\n    \n        .date {\n          display: flex;\n          flex-direction: column;\n          justify-content: center;\n    \n        .title,\n          .date-publication {\n            display: flex;\n            margin: 0;\n          }\n  \n          .title {\n            font-size: 18px;\n            color: #050505;\n            font-weight: 600;\n          }\n  \n          .date-publication {\n            color: #65676b;\n            font-size: 15px;\n          }\n        }\n      }\n    \n      .teny {\n        p {\n          font-size: 17px;\n        }\n    \n        img,video {\n          margin: 0;\n          padding: 0;\n          width: 100%; \n          height: auto;\n          border-radius: 5px;\n          display: block;\n        }\n    \n        .audio-container{\n          display: flex;\n          flex-direction: column;\n          margin: 10px auto;\n        }\n      }\n    \n      .theme-teny {\n        p{\n          font-size: 18px;\n          font-weight: 550;\n        }\n      }\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
